import {
  SiReact,
  SiHtml5,
  SiCss,
  SiJavascript,
  SiTypescript,
  SiBootstrap,
  SiRedux,
  SiAntdesign,
  SiDotnet,
  SiPython,
  SiSpringboot,
  SiRabbitmq,
  SiPostgresql,
  SiMysql,
  SiMongodb,
  SiSqlite,
  SiGit,
  SiGithub,
  SiDocker,
  SiKubernetes,
  SiGithubactions,
  SiJenkins,
  SiGooglecloud,
  SiNetlify,
  SiVercel,
  SiJira,
  SiIntellijidea,
  SiFigma,
  SiCanvas,
  SiPostman,
  SiSwagger,
  SiNpm,
  SiEslint,
  SiPrettier,
  SiJest,
  SiVitest,
  SiJunit5,
  SiCypress,
  SiK6,
  SiVite,
} from "react-icons/si";
import {
  FaDatabase,
  FaTools,
  FaInfinity,
  FaBug,
  FaServer,
  FaJava,
  FaNodeJs,
} from "react-icons/fa";
import { HiOutlineDesktopComputer } from "react-icons/hi";
import { PiFileCSharpLight } from "react-icons/pi";
import { VscAzure, VscVscode } from "react-icons/vsc";

export const techStack = [
  {
    category: "Frontend",
    description: "Building responsive and dynamic user interfaces.",
    icon: HiOutlineDesktopComputer,
    items: [
      { name: "React.js", Icon: SiReact, color: "text-[#61DAFB]" },
      { name: "HTML5", Icon: SiHtml5, color: "text-[#E34F26]" },
      { name: "CSS3", Icon: SiCss, color: "text-[#1572B6]" },
      { name: "JavaScript", Icon: SiJavascript, color: "text-[#F7DF1E]" },
      { name: "TypeScript", Icon: SiTypescript, color: "text-[#007ACC]" },
      { name: "Bootstrap", Icon: SiBootstrap, color: "text-[#7952B3]" },
      { name: "Redux", Icon: SiRedux, color: "text-[#764ABC]" },
      { name: "Ant Design", Icon: SiAntdesign, color: "text-[#0170FE]" },
      { name: "Vite", Icon: SiVite, color: "text-[#646CFF]" },
    ],
  },
  {
    category: "Backend",
    description: "Creating APIs and server-side applications.",
    icon: FaServer,
    items: [
      { name: "C#", Icon: PiFileCSharpLight, color: "text-[#239120]" },
      { name: "Java", Icon: FaJava, color: "text-[#F89820]" },
      { name: "Python", Icon: SiPython, color: "text-[#3776AB]" },
      { name: "ASP.NET Core", Icon: SiDotnet, color: "text-[#512BD4]" },
      { name: "Node.js", Icon: FaNodeJs, color: "text-[#339933]" },
      { name: "Spring Boot", Icon: SiSpringboot, color: "text-[#6DB33F]" },
      { name: "RabbitMQ", Icon: SiRabbitmq, color: "text-[#FF6600]" },
    ],
  },
  {
    category: "Database",
    description: "Managing and designing efficient data storage solutions.",
    icon: FaDatabase,
    items: [
      { name: "PostgreSQL", Icon: SiPostgresql, color: "text-[#336791]" },
      { name: "MySQL", Icon: SiMysql, color: "text-[#4479A1]" },
      { name: "MongoDB", Icon: SiMongodb, color: "text-[#47A248]" },
      { name: "SQLite", Icon: SiSqlite, color: "text-[#003B57]" },
    ],
  },
  {
    category: "DevOps",
    description: "Deployment, CI/CD, and containerization.",
    icon: FaInfinity,
    items: [
      { name: "Git", Icon: SiGit, color: "text-[#F05032]" },
      { name: "GitHub", Icon: SiGithub, color: "text-[#fafbfc]" },
      { name: "Docker", Icon: SiDocker, color: "text-[#2496ED]" },
      { name: "Kubernetes", Icon: SiKubernetes, color: "text-[#326CE5]" },
      {
        name: "GitHub Actions",
        Icon: SiGithubactions,
        color: "text-[#2088FF]",
      },
      { name: "Jenkins", Icon: SiJenkins, color: "text-[#D24939]" },
      { name: "Google Cloud", Icon: SiGooglecloud, color: "text-[#4285F4]" },
      { name: "Azure", Icon: VscAzure, color: "text-[#0089D6]" },
      { name: "Netlify", Icon: SiNetlify, color: "text-[#00C7B7]" },
      { name: "Vercel", Icon: SiVercel, color: "text-[#FFFFFF]" },
      { name: "Jira", Icon: SiJira, color: "text-[#0052CC]" },
    ],
  },
  {
    category: "Testing",
    description: "Ensuring code quality and reliability.",
    icon: FaBug,
    items: [
      { name: "Jest", Icon: SiJest, color: "text-[#C21325]" },
      { name: "Vitest", Icon: SiVitest, color: "text-[#646CFF]" },
      { name: "JUnit 5", Icon: SiJunit5, color: "text-[#25A162]" },
      { name: "Cypress", Icon: SiCypress, color: "text-[#00C7B7]" },
      { name: "K6", Icon: SiK6, color: "text-[#FF4B00]" },
    ],
  },
  {
    category: "Tools",
    description: "Design, coding, and productivity tools.",
    icon: FaTools,
    items: [
      { name: "VS Code", Icon: VscVscode, color: "text-[#007ACC]" },
      { name: "IntelliJ IDEA", Icon: SiIntellijidea, color: "text-[#ED1D56]" },
      { name: "Figma", Icon: SiFigma, color: "text-[#F24E1E]" },
      { name: "Canva", Icon: SiCanvas, color: "text-[#00C4CC]" },
      { name: "Postman", Icon: SiPostman, color: "text-[#FF6C37]" },
      { name: "Swagger", Icon: SiSwagger, color: "text-[#85EA2D]" },
      { name: "npm", Icon: SiNpm, color: "text-[#CB3837]" },
      { name: "ESLint", Icon: SiEslint, color: "text-[#4B32C3]" },
      { name: "Prettier", Icon: SiPrettier, color: "text-[#F7B93E]" },
    ],
  },
];
